export function buildQueryString(params: Record<string, any>):string {
    const queryParts: string[] = [];

    Object.entries(params).forEach(([key, value]) => {
        if (Array.isArray(value)) {
            value.forEach(val => {
                queryParts.push(`${encodeURIComponent(key)}[]=${encodeURIComponent(val)}`);
            });
        } else if (value !== undefined && value !== null && value !== '') {
            queryParts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
        }
    });

    return queryParts.join('&');
}